// test1775
(1775 && 0);
